//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { convertTime, convertMSToDHMS } from '../../components/helpers.js'
import { queue } from './BrigadeRequestsQueue.js'

export default {
  mixins: [queue],
  props: {
    brigade: {
      // brigadeId, + customOrder
      type: Object,
      default () {
        return null
      }
    },
    // У основной заявки установлен флаг target = true
    brigadeRequestsQueue: {
      type: Array,
      default () {
        return []
      }
    },
    request: {
      // Нужно, только если заявка в статусе BS0 или BS1
      type: Object,
      default () {
        return null
      }
    },
    heightTable: {
      type: Number,
      default: 300
    }
  },
  data: function () {
    return {
      columns: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: 'name',
          classes: 'class-bordered'
        },
        {
          name: 'serviceObjectName',
          label: 'Объект',
          align: 'left',
          field: 'serviceObjectName',
          classes: 'class-bordered'
        },
        {
          name: 'priority',
          label: 'Приоритет',
          align: 'center',
          field: 'priority',
          classes: 'class-bordered'
        },
        {
          name: 'state',
          label: 'Состояние',
          align: 'left',
          field: 'state',
          format: this.formatRequestState,
          classes: 'class-bordered'
        },
        {
          name: 'startTime',
          label: 'Начало',
          align: 'left',
          field: 'startTime',
          format: this.formatDateTime,
          classes: 'class-bordered'
        },
        {
          name: 'endTime',
          label: 'Окончание',
          align: 'left',
          field: 'endTime',
          format: this.formatDateTime,
          classes: 'class-bordered'
        },
        {
          name: 'travelTime',
          label: 'Перемещение',
          align: 'left',
          field: 'travelTime',
          format: this.convertMSToDHMS,
          classes: 'class-bordered'
        },
        {
          name: 'travelDistance',
          label: 'Расстояние',
          align: 'right',
          field: 'travelDistance',
          format: this.formatRequestTravelDistance,
          classes: 'class-bordered'
        },
        {
          name: 'executionDuration',
          label: 'Выполнение',
          align: 'center',
          field: 'executionDuration',
          format: this.convertMSToDHMS,
          classes: 'class-bordered'
        },
        {
          name: 'deadline',
          label: 'Дедлайн',
          align: 'center',
          field: 'deadline',
          format: this.formatDateTime,
          classes: 'class-bordered'
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      selected: null,
      brigadeRequests: []
    }
  },
  watch: {
    brigadeRequestsQueue: {
      handler: function (value) {
        this.brigadeRequests = value
      },
      immediate: true
    }
  },
  methods: {
    formatRequestState: function (state) {
      return state ? state.name : ''
    },
    formatDateTime: function (millis) {
      return millis !== undefined ? convertTime(millis) : ''
    },
    convertMSToDHMS: function (millis) {
      return millis !== undefined ? convertMSToDHMS(millis) : ''
    },
    formatRequestTravelDistance: function (value) {
      return value !== undefined ? ((value / 1000).toFixed(1) + 'км') : ''
    },

    // TODO
    clear: function () {
      this.selectedRequest = null
      this.updateButtons()
    },
    onClickRow: function (row) {
      this.selected = row.id
      this.onRequestSelected(row)
    }
  }
}

